import { combineReducers } from 'redux';
import { trackerReducer } from 'lib/funnel-auditor';
import { uiReducer } from 'lib/funnel-auditor';

export default combineReducers({
	tracker: trackerReducer,
	ui: uiReducer
});
